import { cn } from '@/lib/cn';

export interface SkipLinkProps {
  /** Element id to focus when activated. Defaults to "main-content". */
  target?: string;
  label?: string;
  className?: string;
}

/**
 * Hidden until focused — visible at the top-left of the viewport. Lets keyboard users
 * jump from the address bar straight to the main region without tabbing through nav.
 */
export function SkipLink({ target = 'main-content', label = 'Saltar al contenido', className }: SkipLinkProps) {
  return (
    <a
      href={`#${target}`}
      className={cn(
        'sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-skip',
        'focus:rounded-md focus:bg-brand focus:px-3 focus:py-2 focus:text-13 focus:font-medium focus:text-brand-contrast focus:shadow-md focus:outline-none',
        className,
      )}
    >
      {label}
    </a>
  );
}
